import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rtiCapitalize', standalone: true })
export class CapitalizePipe implements PipeTransform {
  public transform(text: string): string {
    if (text === '') {
      return text;
    } else {
      const first = text.slice(0, 1);
      const rest = text.slice(1);
      return `${first.toUpperCase()}${rest}`;
    }
  }
}
